<template>
  <div class="container">
    <RouterLink :to="{ name: RouteList.UI.ICONS.NAME }">Icons</RouterLink>
  </div>
</template>

<script lang="ts" setup>
import { RouteList } from '@/routes/RouteList'
</script>
